define('views/modules/calendar/calendar-item-daily-stats',[
    'underscore', 'backbone', 'utils', 'mustache',
    // services
    'services/unit-converter',
    'services/user',
    // template
    'text!templates/modules/calendar/calendar-item-daily-stats.html',
    // events
    'services/events/animated-session-events',
], function(
    _, Backbone, U, Mustache,
    // services
    UnitConverter,
    User,
    // template
    TCalendarItemDailyStats,
    // events
    AnimationEvents
) {

    var VCalendarItemDailyStats = Backbone.Epoxy.View.extend({
        template: TCalendarItemDailyStats,

        events: {
            'focus input': 'onInputFocus',
            'focusout input': 'onInputFocusOut',
            'keyup input': 'onCalorieChange',
            'change input#distance': 'onDistanceChange'
        },

        initialize: function() {
            this.originalDistanceUnit = this.model.get('distanceUnit');
            this.originalDistanceValue = this.model.get('distanceValue');
            this.originalConvertedValue = this.getDistanceValue();

            this.listenTo(this.model, 'change sync', this.render);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                userDistanceUnit: this.getUserDistanceUnit(),
                distanceValue: this.getDistanceValue()
            })));
            this.applyBindings();
            return this;
        },

        getDistanceValue: function(convert) {
            convert = convert || true;
            var value = this.model.get('distanceValue'),
                from = this.model.get('distanceUnit'),
                to = this.getUserDistanceUnit();

            if (convert && value) {
                value = UnitConverter.convert(value, from, to);
            }

            return value;
        },

        getUserDistanceUnit: function() {
            return User.get('units') ? User.get('units').distance : 'km';
        },

        setDistanceData: function(unit, value) {
            this.model.set('distanceUnit', unit);
            this.model.set('distanceValue', value);
        },

        onInputFocus: function(e) {
            var $input = Backbone.$(e.target);
            if (parseInt($input.val()) === 0) {
                $input.val("");
            }
        },

        onInputFocusOut: function(e) {
            var $input = Backbone.$(e.target);
            if (!$input.val()) {
                $input.val(0);
            }
        },

        onCalorieChange: function(e) {
            var $input = Backbone.$(e.target);
            var model = this.model;
            AnimationEvents.sessionStatsKeypress(model, e.currentTarget.name, e, $input.val());
        },

        onDistanceChange: function(e) {
            var $input = Backbone.$(e.target);

            this.setDistanceData(this.originalDistanceUnit, this.originalDistanceValue);

            if ($input.val() !== this.originalConvertedValue.toString()) {
                this.setDistanceData(this.getUserDistanceUnit(), parseFloat($input.val()));
            }
        }

    });

    return VCalendarItemDailyStats;
});

